// lib/authenticatedFetch.ts
import { createClient } from "@/lib/supabase/client";

export async function authenticatedFetch(
  input: RequestInfo,
  init: RequestInit = {},
): Promise<Response> {
  const supabase = createClient();
  
  if (!supabase) {
    throw new Error("Supabase client not available. This function can only be called from client-side code.");
  }
  
  const {
    data: { session },
  } = await supabase.auth.getSession();

  if (!session?.access_token) {
    throw new Error("Authentication token is missing");
  }

  const headers = new Headers(init.headers || {});
  headers.set("Authorization", `Bearer ${session.access_token}`);
  headers.set("Content-Type", "application/json");

  return fetch(input, {
    ...init,
    headers,
  });
}
